import { createStore, applyMiddleware, combineReducers } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { save, load } from "redux-localstorage-simple";
import thunk from "redux-thunk";
import authReducer from "./authReducer";
import productReducer from "./productReducer";
import requestReducer from "./requestReducer";
import errorReducer from "./errorReducer";
import loginErrorReducer from "./loginErrorReducer";
import storeReducer from "./storeReducer";
import * as actions from "./../actions/actionTypes";

const reducers = combineReducers({
  auth: authReducer,
  products: productReducer,
  request: requestReducer,
  error: errorReducer,
  stores: storeReducer,
  authError: loginErrorReducer,
});

const allReducer = (state:any, action:any) => {
  if (action.type === actions.LOGOUT) {
    console.log("root logout")
    state = undefined;
  }
  return reducers(state, action);
};

const createStoreWithMiddleware = composeWithDevTools(applyMiddleware(thunk, save({
        states: ['auth'],
        namespace: 'beta'
      })))(
  createStore
);

const rootReducer = createStoreWithMiddleware(allReducer, load({
        states: ['auth'],
        namespace: 'beta'
      }));

export default rootReducer;
